import { useGetEmpPhotoQuery } from '@Store/api/dictionaryApiSlice';
import { User, UserReplacement } from '@Types/index';
import { Avatar, List } from 'antd';

interface EmployeeItem {
  chosenUser: User | UserReplacement | null;
  user: User | UserReplacement;
  onUserClick: (user: User | UserReplacement) => void;
}

const AVATAR_SIZE = 32;

const EmployeeItem: React.FC<EmployeeItem> = ({
  user,
  onUserClick,
  chosenUser,
}) => {
  const { data: userPhoto } = useGetEmpPhotoQuery(user.empImageName || '');

  return (
    <List.Item
      key={user.empNumber}
      onClick={() => onUserClick(user)}
      className={
        chosenUser?.empNumber === user.empNumber ? 'chosenUser' : undefined
      }
    >
      <List.Item.Meta
        avatar={<Avatar size={AVATAR_SIZE} src={userPhoto} />}
        title={<span>{user.empName}</span>}
        description={<span>{user.occupation}</span>}
      />
    </List.Item>
  );
};

export default EmployeeItem;
